import {
  faCartShopping,
  faDollarSign,
  faGift,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import "./Dashboard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBillWave } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";

import { Modal, Button } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import AccountingTable from "../../Components/AccountingTable";
import CircularProgressBar from "../../Components/CircularProgressBar";
import BarChart3D from "../../Components/BarChart";

import DailyTransactions from "../../Components/DailyTransactions";
import API from "../../Api/axiosConfig";
import ExpensesChartPro from "../../Components/Totalexpens";
import MyInput from "../../Components/Myinput";

function Dashboard() {
  const [loading, setLoading] = useState(true); // ✅ حالة التحميل
  const [basicInfo, setBasicInfo] = useState({});
  const [cash, setCash] = useState({});
  const [monthlyData, setMonthlyData] = useState([]);
  const [totalMonthlycosts, setTotalMonthlycosts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [showModal5, setShowModal5] = useState(false);
  const [showModal6, setShowModal6] = useState(false);
  const [showModal7, setShowModal7] = useState(false);
  const [showModal8, setShowModal8] = useState(false);
  const [showModal9, setShowModal9] = useState(false);
  const [showModal10, setShowModal10] = useState(false);
  const [showModal11, setShowModal11] = useState(false);
  const [dailyInvoiceModal, setShowDailyInvoiceModal] = useState(false);
  const [cashAccounts, setCashAccounts] = useState([]);
  const [dailyTransactions, setDailyTransactions] = useState({
    invoices: [],
  });
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [profitPercentage, setProfitPercentage] = useState(0);
  const [netProfit, setNetProfit] = useState(0);

  const [totalAmount, setTotalAmount] = useState(null);
  const token = localStorage.getItem("authToken");

  const [bestSellingItems, setBestSellingItems] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [shortagesItems, setShortagesItems] = useState([]);
  const [totalWithdraws, setTotalWithdraws] = useState([]);
  const [totalDepitors, setTotalDepitors] = useState(0);
  const [depitors, setDepitors] = useState([]);
  const [formattedData, setFormattedData] = useState([
    {
      label: "العمولات",
      value: 0,
      color: "purple",
    },
    {
      value: 0,
      label: "الخصومات",
      color: "blue",
    },
  ]);
  const [monthlyCommissionData, setMonthlyCommissionData] = useState([]);
  const [selectedDateKey, setSelectedDateKey] = useState("");

  const arabicMonths = [
    "", // تجاهل index 0 لأن الأشهر تبدأ من 1
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await API.get("analysis");
        const bestItems = response.data?.data?.top_selling_services || [];
        const cash = response.data?.data?.cash_bank_balance_exsist || [];
        const shortages = response.data?.data?.top_selling_services || [];
        const totalWithdraws =
          response.data?.data?.monthly_owner_withdrawals || [];
        const totalRevenue = response.data?.data?.monthly_revenue_cost || [];
        const totalCosts = response.data?.data?.monthly_expenses_costs || [];
        const netProfitPercent =
          response.data?.data?.monthly_net_profit[0].net_profit_percentage ||
          [];

        const amount = response.data?.data?.latest_transaction?.total_amount;
        // const dailyTransaction = response.data?.data?.daily_journal;
        const totalDepitors =
          response.data?.data.customer_balance.totals.total_debtors;
        const depitors = response.data?.data.customer_balance.debtors;
        const monthlyCommissionDeductions =
          response.data?.data.monthly_commission_deductions;
        const transformedShortages = shortages.map((item, index) => ({
          id: index + 1,
          item: item.item_name,
          unit: item.unit_name,
          minimum: item.minimum,
          actual: item.quantity,
          warehouse: item.warehouse_name,
        }));

        const accounts = response.data?.data?.cashAccountsWithBalance || [];
        setCashAccounts(accounts);

        setShortagesItems(transformedShortages);
        setCash(cash);
        setTotalAmount(amount);
        setBestSellingItems(bestItems);
        setTotalWithdraws(totalWithdraws);
        setMonthlyData(totalRevenue);
        setTotalMonthlycosts(totalCosts);
        // setDailyTransactions(dailyTransaction);
        setNetProfit(netProfitPercent);
        // console.log(netProfitPercent);

        setTotalDepitors(totalDepitors);
        setDepitors(depitors);
        setMonthlyCommissionData(monthlyCommissionDeductions);

        // اختار أول تاريخ كافتراضي
        // if (monthlyCommissionDeductions.length > 0) {
        //   const first = monthlyCommissionDeductions[0];
        //   const key = first.month;
        //   setSelectedDateKey(key);

        //   setFormattedData([
        //     {
        //       label: "العمولات",
        //       value: first.total_commission || 0,
        //       color: "purple",
        //     },
        //     {
        //       label: "الخصومات",
        //       value: first.total_deduction || 1,
        //       color: "blue",
        //     },
        //   ]);
        // }

        // setFormattedData([
        //   {
        //     label: `(%${monthlyCommissionDeductions.total_commission > 0 ?monthlyCommissionDeductions.total_commission : 1}) العمولات`,
        //     value: monthlyCommissionDeductions.total_commission > 0 ?monthlyCommissionDeductions.total_commission : 1,
        //     color: "purple",
        //   },
        //   {
        //     value: monthlyCommissionDeductions.total_deduction > 0 ?monthlyCommissionDeductions.total_deduction : 1,
        //     label: `(%${monthlyCommissionDeductions.total_deduction > 0 ?monthlyCommissionDeductions.total_deduction : 1}) الخصومات`,
        //     color: "blue",
        //   },
        // ]);

        const basic = response.data.data.basic_info;
        setBasicInfo(basic);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // نوقف التحميل بعد ما نخلص
      }
    };

    fetchData();
  }, [token]);

  const [dataset, setDataset] = useState([]);
  // console.log(dailyTransactions);
  // 📅 ضبط التاريخ الافتراضي لأول وآخر الشهر
  useState(() => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    };

    setFrom(formatDate(firstDay));
    setTo(formatDate(lastDay));
  }, []);
  const allMonths = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const [counts, setCounts] = useState({
    customer_count: 0,
    supplier_count: 0,
  });

  const [chartData, setChartData] = useState([]);
  const [accountsDetails, setAccountsDetails] = useState([]);

  const [ratios, setRatios] = useState({
    current_ratio: { result: 0, currentAssets: 0, currentLiabilities: 0 },
    quick_ratio: {
      result: 0,
      currentAssets: 0,
      inventory: 0,
      currentLiabilities: 0,
    },
    cash_ratio: { result: 0, cash: 0, currentLiabilities: 0 },
    return_on_assets: { result: 0, netProfit: 0, totalAssets: 0 },
    debt_ratio: { result: 0, totalLiabilities: 0, totalAssets: 0 },
    net_asset: { result: 0, totalLiabilities: 0, totalEquity: 0 },
  });

  // console.log(totalDepitors);
  const handleFilterClick = () => {
    const selected = monthlyCommissionData.find(
      (item) =>
        String(item.month) === String(selectedMonth) &&
        String(item.year) === String(selectedYear)
    );

    if (selected) {
      setFormattedData([
        {
          label: `العمولات`,
          value: selected.total_commission || 1,
          color: "purple",
        },
        {
          label: `الخصومات`,
          value: selected.total_deduction || 1,
          color: "blue",
        },
      ]);
    } else {
      setFormattedData([]);
    }
  };

  if (loading) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-violet">
        <div
          className="spinner-border text-primary"
          style={{ width: "4rem", height: "4rem" }}
          role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 fw-semibold text-white fs-5">
          جارٍ تحميل البيانات...
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="dashboard">
        <div className="content p-4 gap-4">
          <div className="flex20 flex-column flex-sm-row align-items-center gap-3">
            <div className="con_cards gap-3">
              <div className="card_dashbord">
                <span className="spans_card">{"النقدية المتوافرة"}</span>
                <div
                  className="card_icon "
                  onClick={() => setShowModal11(true)}>
                  <div className="doler">
                    <span className="flex items-center gap-1 text-green-600 text-lg">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/9/98/Saudi_Riyal_Symbol.svg"
                        alt="شعار الشركة"
                        style={{
                          width: "30px",
                          height: "auto",
                          borderRadius: "8px",
                        }}
                      />
                    </span>
                  </div>
                </div>
                <span className="spans_card mt-0 mr">{cash.total_balance}</span>
              </div>
              <div className="card_dashbord">
                <span className="spans_card"> اجمالي المسحوبات</span>
                <div className="card_icon" onClick={() => setShowModal(true)}>
                  <div className="doler">
                    <FontAwesomeIcon icon={faCartShopping} />
                  </div>
                </div>
              </div>
              <div className="card_dashbord">
                <span className="spans_card"> {"اكثر الخدمات مبيعا"}</span>
                <div className="card_icon" onClick={() => setShowModal2(true)}>
                  <div className="doler">
                    <FontAwesomeIcon icon={faGift} />{" "}
                  </div>
                </div>
                <sapn className="spans_card mt-0 mr">
                  {" "}
                  {bestSellingItems[0]?.service_name}
                </sapn>
              </div>
            </div>
            <div className="big_card">
              <table className="summary-table-horizontal">
                <thead>
                  <tr>
                    <th>اسم الشركة</th>
                    <th>عدد العملاء</th>
                    <th> عدد الموظفين</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{basicInfo.company_name || ""}</td>
                    <td>{basicInfo.customers_count || 0}</td>
                    <td>{basicInfo.employees_count || 0}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="flex20 flex-column flex-sm-row align-items-center gap-3">
            <div className="conchart">
              <div className="chart fddfd">
                <ExpensesChartPro
                  tytle="إجمالى الإيرادات"
                  smallLabel={{ l: "الإيرادات", r: "تكلفة الخدمات" }}
                  data={monthlyData}
                  revenueField="total_revenue"
                  costField="total_cost"
                />
              </div>
            </div>
            <div className="conchart">
              <div className="chart fddfd">
                <ExpensesChartPro
                  tytle="إجمالى المصروفات"
                  smallLabel={{ l: "مصروفات عامة", r: "تكلفة الخدمات" }}
                  data={totalMonthlycosts}
                  revenueField="general_expenses"
                  costField="service_costs"
                />
                {/* <TickPlacementBars />{" "} */}
              </div>
            </div>
          </div>

          <div className="flex20 flex-sm-row align-items-center gap-3">
            {/* <div className="conchart">
              <div className="chart fddfd justif-content-between p-4">
                <div className="asad">
                  <div className="label-container">
                    <div className="label-item" onClick={() => setShowModal9(true)}>
                      <span className="color-box dark-blue"></span>
                      <span className="label-text"> {"الذمم الدائنة")} </span>
                    </div>

                    <div
                      className="label-item"
                      onClick={() => setShowModal10(true)}>
                      <span className="color-box cyan"></span>
                      <span className="label-text"> {"الذمم المدينة"} </span>
                    </div>
                  </div>
                  <BarChart3D data={formattedData} />
                </div>
                <table className="daily-table direction-rtl">
                  <thead>
                    <tr>
                      <th>م</th>
                      <th>رقم الفاتورة</th>
                      <th>التاريخ</th>
                      <th>القيمة (ج.م)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dailyTransactions.invoices.map((row, index) => (
                      <tr key={index}>
                        <td style={{ textAlign: "center" }}>{index + 1}</td>
                        <td style={{ textAlign: "center" }}>
                          {row.invoice_number}
                        </td>
                        <td style={{ textAlign: "center" }}>{row.date}</td>
                        <td style={{ textAlign: "center" }}>{row.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>{" "}
              </div>
            </div> */}
            <div className="conchart gap-3 flex-column flex-sm-row">
              <div className="dount">
                <div className="asad">
                  <div className="label-container">
                    {/* <div className="label-item" onClick={() => setShowModal9(true)}>
                      <span className="color-box dark-blue"></span>
                      <span className="label-text"> {"الذمم الدائنة"} </span>
                    </div> */}

                    <div
                      className="label-item"
                      onClick={() => setShowModal10(true)}>
                      <span className="label-text"> {"الذمم المدينة"} </span>
                      <span className="color-box cyan"></span>
                    </div>
                  </div>
                  {/* <BarChart3D data={formattedData} /> */}
                  <div className="counter-container">
                    <div className="counter-box">
                      <span className="counter-label">{"الذمم المدينة"}</span>
                      <span className="counter-value">{totalDepitors}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="dount p-4 shadow-sm bg-white d-flex flex-column justify-content-center align-items-center text-center"
                style={{ height: "417px" }}>
                <h4 className="mb-4 fw-bold">الفواتير اليومية</h4>

                <div className="w-100 d-flex flex-column align-items-center gap-3 px-3">
                  <MyInput
                    label="حدد التاريخ:"
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                  />
                  {/* analysis?date?from=25-10-2025&to=26-10-2025 */}
                  <button
                    className="btn px-4 py-2"
                    onClick={async () => {
                      try {
                        const response = await API.get(
                          `analysis?date=${selectedDate}`
                        );
                        const dailyData = response.data?.data?.daily_journal;

                        if (dailyData) {
                          setDailyTransactions(dailyData);
                          setShowDailyInvoiceModal(true);
                        } else {
                          setDailyTransactions(null);
                        }
                      } catch (error) {
                        console.error("Error fetching daily invoices:", error);
                      }
                    }}>
                    إجمالي الفواتير
                  </button>
                </div>
              </div>
            </div>
            <div className="conchart flex-column flex-sm-row flex-sm-row gap-3">
              <div className="dount">
                <sapn className="spanss">صافي الربح</sapn>
                <div className="cahrt_dount">
                  <CircularProgressBar
                    percentage={parseFloat(netProfit)}
                    size={200}
                    strokeWidth={30}
                    bgColor="#var(--cirprogress)"
                    useGradient={true}
                    gradientStartColor="#950d6e"
                    gradientEndColor="#1952af"
                    textColor="var(--text-color)"
                    shadowColor="rgba(177, 17, 226, 0.69)"
                    shadowOffsetY="6px"
                    shadowBlur="12px"
                  />
                </div>
              </div>
              {/* <div className="dount"><Fs /></div> */}
              <div className="dount">
                <div className="asad">
                  {monthlyCommissionData.length > 0 && (
                    <div style={{ textAlign: "center", marginBottom: "20px" }}>
                      <div
                        className="d-flex justify-content-start align-items-center p-3 gap-2 mb-1"
                        dir="rtl"
                        style={{ flexWrap: "wrap" }}>

                        {/* اختيار السنة */}
                        <MyInput
                          as="select"
                          className="d-inline-block"
                          style= {{width: "800px"}}
                          // label={"السنة"}
                          value={selectedYear}
                          onChange={(e) => setSelectedYear(e.target.value)}
                          options={[
                            { value: "", label: "اختر السنة" },
                            ...[
                              ...new Set(
                                monthlyCommissionData.map((d) => d.year)
                              ),
                            ].map((y) => ({
                              value: y,
                              label: y,
                            })),
                          ]}
                        />
                        {/* اختيار الشهر */}
                        <MyInput
                          as="select"
                          // label="الشهر"
                          value={selectedMonth}
                          onChange={(e) => setSelectedMonth(e.target.value)}
                          options={[
                            { value: "", label: "اختر الشهر" },
                            ...[
                              ...new Set(
                                monthlyCommissionData.map((d) => d.month)
                              ),
                            ].map((m) => ({
                              value: m,
                              label:
                                [
                                  "",
                                  "يناير",
                                  "فبراير",
                                  "مارس",
                                  "أبريل",
                                  "مايو",
                                  "يونيو",
                                  "يوليو",
                                  "أغسطس",
                                  "سبتمبر",
                                  "أكتوبر",
                                  "نوفمبر",
                                  "ديسمبر",
                                ][m] || m,
                            })),
                          ]}
                        />

                        {/* الزرار */}
                        <button
                          className="btn btn-primary"
                          onClick={() => handleFilterClick()}
                          disabled={!selectedMonth || !selectedYear}>
                          عرض
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="label-container">
                    <div className="label-item">
                      <span className="label-text"> العمولات </span>
                      <span className="color-box dark-blue"></span>
                    </div>

                    <div className="label-item">
                      <span className="label-text"> الخصومات </span>
                      <span className="color-box blue"></span>
                    </div>
                  </div>
                  <BarChart3D data={formattedData} />
                  {/* <div className="counter-container">
                    <div className="counter-box">
                      <span className="counter-label">
                        الذمم المدينة
                      </span>
                      <span className="counter-value">{totalDepitors}</span>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Deficiencies */}
      <Modal show={showModal} onHide={() => setShowModal(false)} className="">
        <Modal.Header className="d-flex justify-content-between">
          <Modal.Title>اجمالى المسحوبات</Modal.Title>
          <Button
            className="custom-close-button"
            variant="link"
            onClick={() => setShowModal(false)}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </Button>
        </Modal.Header>

        <Modal.Body>
          {/* 🗓️ تحديد التاريخ */}
          <div className="row mb-3 justify-content-center">
            <div className="col-md-5">
              <MyInput
                label="إلى"
                type="date"
                value={to}
                onChange={(e) => setTo(e.target.value)}
              />
            </div>
            <div className="col-md-5">
              <MyInput
                label="من"
                type="date"
                value={from}
                onChange={(e) => setFrom(e.target.value)}
              />
            </div>
            <div className="col-12 d-flex align-items-end justify-content-center">
              <Button
                variant="secondary"
                className="w-fit"
                onClick={async () => {
                  try {
                    const response = await API.get(
                      `analysis?date?from=${from}&to=${to}`
                    );
                    const totalwithdraws =
                      response.data?.data?.monthly_owner_withdrawals || [];
                    // console.log(totalwithdraws);

                    if (totalwithdraws) {
                      setTotalWithdraws(totalwithdraws);
                    } else {
                      setTotalWithdraws(null);
                    }
                  } catch (error) {
                    console.error("Error fetching total withdraws:", error);
                  }
                }}>
                عرض
              </Button>
            </div>
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            className="table-dashboard direction-rtl">
            <thead>
              <tr>
                <th>م</th>
                <th>الشهر</th>
                <th>المسحوبات</th>
              </tr>
            </thead>
            <tbody>
              {totalWithdraws.length === 0 ? (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    لا توجد بيانات
                  </td>
                </tr>
              ) : (
                totalWithdraws.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{arabicMonths[item.month]}</td>
                    <td>{item.total_withdrawals}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-center">
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Best_selling_items */}
      <Modal
        show={showModal2}
        onHide={() => setShowModal2(false)}
        className="Jobtitlesreports">
        <Modal.Header>
          <Modal.Title>الخدمات الاكثر مبيعاََ </Modal.Title>
          <Button
            className="custom-close-button"
            variant="link"
            onClick={() => setShowModal2(false)}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </Button>
        </Modal.Header>

        <Modal.Body>
          {/* 🗓️ تحديد التاريخ */}
          <div className="row mb-3 justify-content-center">
            <div className="col-md-5">
              <MyInput
                label="إلى"
                type="date"
                value={to}
                onChange={(e) => setTo(e.target.value)}
              />
            </div>
            <div className="col-md-5">
              <MyInput
                label="من"
                type="date"
                value={from}
                onChange={(e) => setFrom(e.target.value)}
              />
            </div>
            <div className="col-12 d-flex align-items-end justify-content-center">
              <Button
                variant="secondary"
                className="w-fit"
                onClick={async () => {
                  try {
                    const response = await API.get(
                      `analysis?date?from=${from}&to=${to}`
                    );
                    const topSellingServices =
                      response.data?.data?.top_selling_services;
                    // console.log(topSellingServices);

                    if (topSellingServices) {
                      setBestSellingItems(topSellingServices);
                    } else {
                      setBestSellingItems(null);
                    }
                  } catch (error) {
                    console.error(
                      "Error fetching top selling services:",
                      error
                    );
                  }
                }}>
                عرض
              </Button>
            </div>
          </div>
          <Table
            striped
            bordered
            hover
            size="sm"
            className="table-dashboard direction-rtl">
            <thead>
              <tr>
                <th>م</th>
                <th>إسم الخدمة</th>
                <th>عدد مرات البيع</th>
              </tr>
            </thead>
            <tbody>
              {bestSellingItems.length === 0 ? (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    لا توجد بيانات
                  </td>
                </tr>
              ) : (
                bestSellingItems.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.service_name}</td>
                    <td>{item.sales_count}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal2(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* moda1 10 */}
      <Modal
        show={showModal11}
        onHide={() => setShowModal11(false)}
        className="Jobtitlesreports">
        <Modal.Header>
          <Modal.Title>النقدية المتوفرة</Modal.Title>
          <Button
            className="custom-close-button"
            variant="link"
            onClick={() => setShowModal11(false)}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </Button>
        </Modal.Header>

        <Modal.Body>
          <Table
            striped
            bordered
            hover
            size="sm"
            className="table-dashboard direction-rtl">
            <thead>
              <tr>
                <th>م</th>
                <th>اسم الحساب</th>
                <th>الرصيد</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>النقدية فى الصندوق</td>
                <td>{cash.cash_balance}</td>
              </tr>
              <tr>
                <td>2</td>
                <td>البنك</td>
                <td>{cash.bank_balance}</td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal11(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Current_ratio */}
      <Modal
        show={showModal3}
        onHide={() => setShowModal3(false)}
        className="modal-dashboard">
        <Modal.Header>
          <Modal.Title></Modal.Title>
          <Button
            className="custom-close-button"
            variant="link"
            onClick={() => setShowModal3(false)}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </Button>
        </Modal.Header>

        <Modal.Body>
          <div className="formula-container">
            <div className="formula-line">
              <span className="label">Current_ratio</span>
              <span className="equals-sign">=</span>
              <div className="fraction">
                <span className="numerator">numerator</span>
                <span className="denominator">denominator</span>
              </div>
            </div>

            <div className="formula-line">
              <div className="fraction">
                <span className="numerator">
                  {Number(ratios.current_ratio.currentAssets).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </span>
                <span className="denominator">
                  {Number(
                    ratios.current_ratio.currentLiabilities
                  ).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </div>
            </div>

            <div className="formula-line me-3 mb-5">
              <span className="denominator">
                ={" "}
                {Number(ratios.current_ratio.result).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal3(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* quick_ratio */}
      <Modal
        show={showModal4}
        onHide={() => setShowModal4(false)}
        className="modal-dashboard">
        <Modal.Header>
          <Modal.Title>quick_ratio</Modal.Title>
          <Button
            className="custom-close-button"
            variant="link"
            onClick={() => setShowModal4(false)}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </Button>
        </Modal.Header>

        <Modal.Body>
          <div className="formula-container">
            <div className="formula-line">
              <span className="label">quick_ratio</span>
              <span className="equals-sign">=</span>
              <div className="fraction">
                <span className="numerator">
                  numerator
                  <span className="paddingd"> - </span>
                  inventory
                </span>
                <span className="denominator">denominator</span>
              </div>
            </div>

            <div className="formula-line">
              <span className="equals-sign">=</span>
              <div className="fraction">
                <span className="numerator">
                  {Number(ratios.quick_ratio.currentAssets).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}{" "}
                  <span className="paddingd">-</span>{" "}
                  {Number(ratios.quick_ratio.inventory).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </span>
                <span className="denominator">
                  {Number(ratios.quick_ratio.currentLiabilities).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </span>
              </div>
            </div>

            <div className="formula-line solve">
              ={" "}
              {Number(ratios.quick_ratio.result).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal4(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Money_ratio */}
      <Modal
        show={showModal5}
        onHide={() => setShowModal5(false)}
        className="modal-dashboard">
        <Modal.Header>
          <Modal.Title>Money_ratio</Modal.Title>
          <Button
            className="custom-close-button"
            variant="link"
            onClick={() => setShowModal5(false)}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </Button>
        </Modal.Header>

        <Modal.Body>
          <div className="formula-container">
            {/* Keep class names */}
            <div className="formula-line">
              <span className="label">Money_ratio</span>
              <span className="equals-sign">=</span>
              <div className="fraction">
                <span className="numerator">
                  cash_funds_label
                  <span style={{ margin: "0 5px" }}></span>
                </span>
                <span className="denominator">denominator</span>
              </div>
            </div>

            <div className="formula-line">
              <span className="equals-sign">=</span>
              <div className="fraction">
                <span className="numerator">
                  {Number(ratios.cash_ratio.cash).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
                <span className="denominator">
                  {Number(ratios.cash_ratio.currentLiabilities).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </span>
              </div>
            </div>

            <div className="formula-line solve">
              =
              {Number(ratios.cash_ratio.result).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal5(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
      {/*  return_on_assets_label*/}
      <Modal
        show={showModal6}
        onHide={() => setShowModal6(false)}
        className="modal-dashboard">
        <Modal.Header>
          <Modal.Title>return_on_assets_label</Modal.Title>
          <Button
            className="custom-close-button"
            variant="link"
            onClick={() => setShowModal6(false)}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </Button>
        </Modal.Header>

        <Modal.Body>
          <div className="formula-container">
            <div className="formula-line">
              <span className="label">return_on_assets_label</span>
              <span className="equals-sign">=</span>
              <div className="fraction">
                <span className="numerator">net_profit_label</span>
                <span className="denominator">total_assets_label</span>
              </div>
            </div>

            <div className="formula-line">
              <span className="equals-sign">=</span>
              <div className="fraction">
                <span className="numerator">
                  {Number(ratios.return_on_assets.netProfit).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </span>
                <span className="denominator">
                  {Number(ratios.return_on_assets.totalAssets).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </span>
              </div>
            </div>

            <div className="formula-line solve">
              =
              {Number(ratios.return_on_assets.result).toLocaleString(
                undefined,
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal6(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* 7 */}
      <Modal
        show={showModal7}
        onHide={() => setShowModal7(false)}
        className="modal-dashboard">
        <Modal.Header>
          <Modal.Title>Return_on_liabilities</Modal.Title>
          <Button
            className="custom-close-button"
            variant="link"
            onClick={() => setShowModal7(false)}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </Button>
        </Modal.Header>

        <Modal.Body>
          <div className="formula-container">
            <div className="formula-line">
              <span className="label">Return_on_liabilities</span>
              <span className="equals-sign">=</span>
              <div className="fraction">
                <span className="numerator">commitments</span>
                <span className="denominator">copyright</span>
              </div>
            </div>

            <div className="formula-line">
              <div className="fraction">
                <span className="numerator">
                  {Number(ratios.net_asset.totalLiabilities).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </span>
                <span className="denominator">
                  {Number(ratios.net_asset.totalEquity).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </span>
              </div>
            </div>

            <div className="formula-line me-3 mb-5">
              <span className="denominator">
                ={" "}
                {Number(ratios.net_asset.result).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal7(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* 8 */}
      <Modal
        show={showModal8}
        onHide={() => setShowModal8(false)}
        className="modal-dashboard">
        <Modal.Header>
          <Modal.Title>debt_ratio_label</Modal.Title>
          <Button
            className="custom-close-button"
            variant="link"
            onClick={() => setShowModal8(false)}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </Button>
        </Modal.Header>

        <Modal.Body>
          <div className="formula-container">
            <div className="formula-line">
              <span className="label">debt_ratio_label</span>
              <span className="equals-sign">=</span>
              <div className="fraction">
                <span className="numerator">total_debt_label</span>
                <span className="denominator">total_assets_label</span>
              </div>
            </div>

            <div className="formula-line">
              <span className="equals-sign">=</span>
              <div className="fraction">
                <span className="numerator">
                  {Number(ratios.debt_ratio.totalLiabilities).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </span>
                <span className="denominator">
                  {Number(ratios.debt_ratio.totalAssets).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}
                </span>
              </div>
            </div>

            <div className="formula-line solve">
              =
              {Number(ratios.debt_ratio.result).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal8(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* 9 */}
      <Modal
        show={showModal9}
        onHide={() => setShowModal9(false)}
        className="modal-dashboard">
        <Modal.Header>
          <Modal.Title>{"Accounts_receivable"}</Modal.Title>
          <Button
            className="custom-close-button"
            variant="link"
            onClick={() => setShowModal9(false)}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </Button>
        </Modal.Header>
        <Modal.Body>
          <AccountingTable
            data={accountsDetails
              .filter((item) => item.type === "customer")
              .map((item, index) => ({
                ...item,
                serial: index + 1,
                formatted_amount: Number(item.total_amount).toLocaleString(
                  "en-US",
                  {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  }
                ),
              }))}
            columns={[
              { key: "serial", name: "serial-number" },
              { key: "name", name: "Customer-name" },
              { key: "formatted_amount", name: "amount_due" },
            ]}
            tableContainerClass="table-dashbardlist"
          />
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal9(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* 10 */}
      <Modal
        show={showModal10}
        onHide={() => setShowModal10(false)}
        className="modal-dashboard">
        <Modal.Header>
          <Modal.Title>الذمم المدينة</Modal.Title>
          <Button
            className="custom-close-button"
            variant="link"
            onClick={() => setShowModal10(false)}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </Button>
        </Modal.Header>

        <Modal.Body className="w-100">
          <Table
            striped
            bordered
            hover
            size="lg"
            className="table-dashboard direction-rtl">
            <thead>
              <tr>
                <th>م</th>
                <th>إسم العميل</th>
                <th>القيمة</th>
              </tr>
            </thead>
            <tbody>
              {depitors.length === 0 ? (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    لا توجد بيانات
                  </td>
                </tr>
              ) : (
                depitors.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.customer_name}</td>
                    <td>{item.remaining_balance}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal10(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* daily inovices */}
      <Modal
        show={dailyInvoiceModal}
        onHide={() => setShowDailyInvoiceModal(false)}
        className="Jobtitlesreports">
        <Modal.Header>
          <Modal.Title>الفواتير اليومية</Modal.Title>
          <Button
            className="custom-close-button"
            variant="link"
            onClick={() => setShowDailyInvoiceModal(false)}>
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </Button>
        </Modal.Header>

        <Modal.Body>
          {dailyTransactions && (
            <>
              {/* <div className="d-flex justify-content-between align-items-center mb-3 px-2">
                        <span>
                          التاريخ: {dailyTransactions?.date || "غير متوفر"}
                        </span>
                        <span>
                          إجمالي الفواتير:{" "}
                          {parseFloat(
                            dailyTransactions?.total_revenue || 0
                          ).toLocaleString()}
                        </span>
                      </div> */}

              <table className="daily-table direction-rtl rounded">
                <thead>
                  <tr>
                    <th>م</th>
                    <th>رقم الفاتورة</th>
                    <th>التاريخ</th>
                    <th>القيمة</th>
                  </tr>
                </thead>
                <tbody>
                  {dailyTransactions.invoices.map((row, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>{index + 1}</td>
                      <td style={{ textAlign: "center" }}>
                        {row.invoice_number}
                      </td>
                      <td style={{ textAlign: "center" }}>{row.date}</td>
                      <td style={{ textAlign: "center" }}>{row.total}</td>
                    </tr>
                  ))}
                  {/* صف الإجمالي */}
                  {(dailyTransactions.invoices.length > 0 && (
                    <tr
                      style={{
                        fontWeight: "bold",
                        backgroundColor: "#f9f9f9",
                      }}>
                      <td colSpan="3" style={{ textAlign: "center" }}>
                        الإجمالي
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {parseFloat(
                          dailyTransactions?.total_revenue || 0
                        ).toLocaleString()}
                      </td>
                    </tr>
                  )) || (
                    <tr className="fw-bold fs-5">
                      <td colSpan={4}>لا يوجد فواتير</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDailyInvoiceModal(false)}>
            close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Dashboard;
